/// successful noti

export const REGISTER_SUCCESSFUL = "Đăng Kí Thành Công"
export const LOGIN_SUCCESSFUL = "Đăng nhập thành công"
export const ERROR = "Thao tác thất bại"

//// error in sign in

export const EMAIL_EXSISTS = "Email already exists"
export const PASSWORD_TOO_SHORT = "Password is too short";
export const INVALID_PASSWORD = "Incorrect password"
export const USER_NOT_FOUND = "Cannot find user"

//// status code error

export const UNAUTHORIZED_CODE = 401
export const NETWORK_ERROR_CODE = 500


//// SIGN_UP NOTF
export const EMPTY_USERNAME = "username không được để trống"
export const EMPTY_EMAIL = "email không được để trống"
export const EMPTY_PASSWORD = "password không được để trống"
export const EMPTY_REPASSWORD = "password xác minh không được để trống"
export const INVALID_REPASSWORD = "password xác minh không chính xác"
export const INVALID_EMAIL = "Vui Lòng nhập email hợp lệ";

